module.exports = __webpack_public_path__ + "static/media/prod_15000_snack.e7419df3.jpg";